module.exports = __webpack_public_path__ + "static/media/footer_akal_logo.585bb341.svg";